"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZODDeviceType = void 0;
var zod_1 = require("zod");
/**
 * This file contains the responses for /device endpoints
 * https://middleware.stage.gs.livesportsanywhere.com/docs/#/Devices
 */
exports.ZODDeviceType = zod_1.z.enum([
    'hbbtv',
    'phone_android',
    'phone_iOS',
    'tablet_android',
    'tablet_iOS',
    'tv_android',
    'tv_fire',
    'tv_generic',
    'tv_lg_webos',
    'tv_ps3',
    'tv_ps4',
    'tv_roku',
    'tv_samsung',
    'tv_xboxone',
    'tvOS',
    'web_browser'
]);
